import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Modal, Popover, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteOrder } from '../../utils/apiBucherVaslin';

const { confirm } = Modal;

const showDeleteConfirm = (intl, id, refresh) => {
    confirm({
        title: intl.formatMessage(
            {
                id: 'table.orders.deleteModal.title',
            },
            { id },
        ),
        okText: intl.formatMessage({
            id: 'common.yes',
        }),
        cancelText: intl.formatMessage({
            id: 'common.no',
        }),
        okType: 'danger',
        async onOk() {
            const { isSuccess, isUnauthorized, errorMessage, errorDetail } = await deleteOrder(id);

            if (isSuccess) {
                message.success(
                    intl.formatMessage(
                        {
                            id: 'table.orders.success',
                        },
                        { id },
                    ),
                    5,
                );

                refresh();

                return;
            }
            Modal.error({
                title: isUnauthorized
                ? intl.formatMessage({ id: 'error.unauthorized.title' })
                : intl.formatMessage({
                    id: 'table.orders.fail',
                }),
                content: isUnauthorized
                ? intl.formatMessage({ id: 'error.unauthorized.message' })
                : errorDetail,
            });
        },
    });
};

const DeleteOrder = ({ intl, id, refresh }) => (
    <Popover content={<FormattedMessage id="table.users.delete" />}>
        <Button htmlType="button" type="danger" onClick={() => showDeleteConfirm(intl, id, refresh)}>
            <FontAwesomeIcon icon="trash-alt" />
        </Button>
    </Popover>
);

DeleteOrder.propTypes = {
    intl: intlShape.isRequired,
    id: PropTypes.string.isRequired,
    refresh: PropTypes.func.isRequired,
};

export default injectIntl(DeleteOrder);
